<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            :editable="editable"
            label="약품명"
            name="title"
            v-model="searchParam.title">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-select
            :editable="editable"
            :comboItems="useFlagItems"
            label="사용여부"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            type="search"
            v-model="searchParam.useFlag">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <c-table
          ref="table"
          title="약품 목록"
          tableId="table"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <c-card title="상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="신규" icon="add" />
              <c-btn
                label="저장"
                icon="save" />
              <c-btn
                label="삭제"
                icon="remove" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-6">
              <c-plant type="edit" name="plantCd" v-model="data.col1" />
            </div>
            <div class="col-12">
              <c-text
                :editable="editable"
                :required="true"
                label="약품명"
                name="sequenceNm"
                v-model="data.col2">
              </c-text>
            </div>
            <div class="col-6">
              <c-select
                codeGroupCd="WEIGHT_UNIT"
                type="edit"
                itemText="codeName"
                itemValue="code"
                name="col3"
                label="단위"
                v-model="data.col3"
              ></c-select>
            </div>
            <div class="col-6">
              <c-radio
                :editable="editable"
                :comboItems="useFlagItems"
                label="사용여부"
                name="col4"
                v-model="data.col4">
              </c-radio>
            </div>
          </template>
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'air-master-07',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
      }),
    },
  },
  data() {
    return {
      data: {
        col1: '',
        col2: '',
        col3: null,
        col4: 'Y',
      },
      searchParam: {
        plantCd: '',
        deptCd: '',
        title: '',
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      editable: true,
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '사업장',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '약품명',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '단위',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '사용여부',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col0: '사업장1',
          col1: '탈취제',
          col2: 'kg',
          col4: 'Y',
        },
        {
          col0: '사업장1',
          col1: 'NaOH',
          col2: 'kg',
          col4: 'Y',
        },
        {
          col0: '사업장1',
          col1: 'H2O',
          col2: 'kg',
          col4: 'Y',
        },
      ]
    },
  }
};
</script>
